import { render, staticRenderFns } from "./BackgroundPicker.vue?vue&type=template&id=8151614e&scoped=true&"
import script from "./BackgroundPicker.vue?vue&type=script&lang=js&"
export * from "./BackgroundPicker.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundPicker.vue?vue&type=style&index=0&id=8151614e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151614e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VItem,VRow,VSpacer})
